<template>
  <div id="showtable">
    <!-- RB -->
    <template v-if="selectedMarket=='1' && Object.keys(sortedRBEventList).length > 0">
      <todayHeader :marketType="market.inPlayMarket.key" @updateMethod="showMarketMatches"></todayHeader>
      <template v-if="showRBhideAll">
        <template v-for="(eventObj, eventObjKey) in sortedRBEventList" >
          <!-- League Capt -->
          <div class="list-card-wrap v-scroll-item relative-position sticky-wrap" style="top: 73.5px;"
            :style="{'height':!showRBLgeEve[eventObjKey].hide ? '56px':'39px', 'top':selectedMarket==market.tdyMarket.key ? '76.5px':'89.5px'}"> <!--style="top: 73.5px;"-->
            <div class="list-card-inner" :key="eventObjKey">
              <div class="c-match-league match-tpl21-bg"
                :class="{ 'match-tpl21': !showRBLgeEve[eventObjKey].hide, 'leagues-pack': showRBLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, true)">
                <div class="tr-match-head">
                  <div class="leagues-wrap" :style="{ width: widthColumn[2] + 'px !important' }">
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                    <div class="league-icon-wrap">
                      <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/00/45/CgURtV8zqyaAYjn2AAAMpJixGIo955.png" style="opacity: 1;"> -->
                    </div>
                    <div class="ellipsis-wrap">
                      <div class="absolute-full">
                        <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                        <span class="league-match-count">{{ eventObj.length }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="play-name vrow col">
                    <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.FULL_TIME'] }}</div>
                    <div class="col bet-col4 y0-col4">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.FIRST_HALF'] }}
                    </div>
                  </div>
                  <div class="yb-flex-center" style="width: 39px !important;">
                    <div class="icon-wrap m-star-wrap-league"
                      :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }" @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                      <i class=" icon-star q-icon c-icon" :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                    </div>
                  </div>
                </div>
                <div class="tr-col-name" v-show="!showRBLgeEve[eventObjKey].hide">
                  <div class="leagues-wrap2" :style="{ width: (widthColumn[2]) + 'px !important' }"></div>
                  <div class="play-name vrow col">
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN'] }}</div>
                  </div>
                  <div style="width: 42px !important;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- League Events -->
          <!-- <template v-if="!sortedRBEventList[eventObjKey].hide" > -->
          <template v-if="!showRBLgeEve[eventObjKey].hide">
            <template v-for="(event, eventKey) in eventObj" v-if="eventKey!='hide'">
              <div class="list-card-wrap v-scroll-item relative-position" style="height: 391px !important; ">
                <div class="list-card-inner">
                  <div class="c-match-card relative-position" style="height: 391px !important;">
                    <div class="c-match-item tpl-21 csid-1">
                      <div class="process-col">
                        <div class="yb-flex-center full-width" style="height: 105px;">
                          <sportTime :event="event"></sportTime>
                        </div>
                      </div>
                      <div class="match-handicap-item-wrap">
                        <div class="match-handicap-item">
                          <sportTeam :event="event" :issc="true" classes="none" :plyType="ftPlyType" :isRB="true" :widthL="widthColumn[0]"></sportTeam>
                          <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                            <div class="vrow no-wrap">
                              <template v-for="ptype in fthtptype"><!-- Full Time & Half Time -->
                                <template v-for="(oddcaptData, n) in itemsRow">
                                  <!-- FT/HT column for home win/draw/away win score -->
                                  <div class="handicap-col">
                                    <template v-for="oddcapt in oddcaptData">
                                      <template v-if="excludeHT(oddcapt, ptype)">
                                        <div class="bet-item-wrap aosnoflex" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                          <div  class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon" :class="'bet-cs-'+ptype">
                                            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <!-- Show score label even no odds -->
                                              <div class="handicap-value-text">
                                                {{ getCSLabel(oddcapt) }}
                                              </div>
                                            </div>
                                            <cstgftht :event="event" :score="oddcapt" :plyType="ptype" :betType="rbbtype" :decimalNumber="1" />
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else-if="n == 0 && oddcapt == 'aos'">
                                        <div class="bet-item-wrap col3 absolute aosnoflex" style="height: 35px !important;"  :style="{ width: (widthColumn[1]*3) + 'px !important' }">
                                          <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon" :class="'bet-cs-'+ptype">
                                            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text AOS">
                                                {{ lang.sportAllBet['ALL_BET.LBL_AOS'] }}
                                              </div>
                                            </div>
                                            <cstgftht :event="event" :score="'aos'" :plyType="ptype" :betType="rbbtype" :decimalNumber="1" />
                                          </div>
                                        </div>
                                      </template> <!--END AOS -->
                                      <template v-else-if="(n == 1 || n == 2) && oddcapt == 'odempty'">
                                        <div class="bet-item-wrap e" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                      <template v-else-if="(n == 1 || n == 2) && oddcapt == 'odlast'">
                                        <div class=" bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                      <template v-else-if="(!excludeHT(oddcapt, ptype) && oddcapt!='aos')">
                                        <div class="bet-item-wrap na" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                    </template>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </div>
                          <div class="media-col">
                            <div class="media-col-wrap">
                              <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                              </div>
                              <div class="yb-flex-center"></div>
                              <div data-v-5a29cfce="" class="icon-wrap relative-position" v-if="tvIconFlag && event.ch>0" :class="{ active: livetvEveid== event.eveid}"> 
                                <div data-v-5a29cfce="" class="v-icon video-icon"  @click="enterAllBet(event,2)" :class="{ active: livetvEveid== event.eveid}" :title="sportAllBetLang['ALL_BET.LBL_ORIGINAL_VIDEO']"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template> <!-- END League Events -->
        </template> <!-- END sortedRBEventList -->
      </template>
    </template>

    <!-- Today/Early -->
    <template v-if="(Object.keys(sortedEventList).length > 0)">
      <todayHeader :marketType="market.tdyMarket.key" @updateMethod="showMarketMatches"></todayHeader>
      <template v-if="showhideAll">
        <template v-for="(eventObj, eventObjKey) in sortedEventList">
          <!-- League Capt -->
          <div class="list-card-wrap v-scroll-item relative-position sticky-wrap"
            :style="{'height':!showLgeEve[eventObjKey].hide ? '56px':'39px', 'top':selectedMarket==market.tdyMarket.key ? '73.5px':'89.5px'}">
            <div class="list-card-inner">
              <div class="c-match-league match-tpl21-bg" 
                :class="{'match-tpl21': !showLgeEve[eventObjKey].hide, 'leagues-pack': showLgeEve[eventObjKey].hide }" @click="showLeg(eventObjKey, false)">
                <div class="tr-match-head">
                  <div class="leagues-wrap" :style="{ width: widthColumn[2] + 'px !important' }">
                    <i size="14px" class="icon-arrow q-icon c-icon"></i>
                    <div class="league-icon-wrap">
                      <!-- <img data-team="undefined" data-csid="undefined" src="https://image.gredfged.com/group1/M00/0C/F3/CgURtWCPHfKAE3dDAAJ_6DbaUxY626.png" style="opacity: 1;"> -->
                    </div>
                    <div class="ellipsis-wrap">
                      <div class="absolute-full">
                        <span class="ellipsis allow-user-select" :title="eventObj[0].lgecapt" v-html="eventObj[0].lgecapt"></span>
                        <span class="league-match-count">{{ eventObj.length }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="play-name vrow col">
                    <div class="col">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.FULL_TIME'] }}</div>
                    <div class="col bet-col4 y0-col4">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.FIRST_HALF'] }}
                    </div>
                  </div>
                  <div class="yb-flex-center" style="width: 39px !important;">
                    <div class="icon-wrap m-star-wrap-league" :class="{ added: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }" @click="favouritelgeve(eventObj[0].lgeid, $event, '0', eventObj)">
                      <i class="icon-star q-icon c-icon" :class="{ active: lgFavorite(eventObj[0].lgeid, selectedBettype.sprtId, favouriteLgeEvents) }"></i>
                    </div>
                  </div>
                </div>
                <div class="tr-col-name" v-show="!showLgeEve[eventObjKey].hide">
                  <div class="leagues-wrap2" :style="{ width: (widthColumn[2]) + 'px !important' }"></div>
                  <div class="play-name vrow col">
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.HOMEWIN'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.DRAW'] }}</div>
                    <div class="col ellipsis">{{ sportTableLang.template_lang['SPORT_TEMPLATE_2.AWAYWIN'] }}</div>
                  </div>
                  <div style="width: 42px !important;"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- League Events -->
          <!-- <template v-if="!sortedEventList[eventObjKey].hide"> -->
          <template v-if="!showLgeEve[eventObjKey].hide">
            <template v-for="(event, eventKey) in eventObj">
              <div class="list-card-wrap v-scroll-item relative-position" style="height: 391px !important; ">
                <div class="list-card-inner">
                  <div class="c-match-card relative-position" style="height: 391px !important;">
                    <div class="c-match-item tpl-21 csid-1">
                      <div class="process-col">
                        <div class="yb-flex-center full-width" style="height: 105px;">
                          <sportTime :event="event"></sportTime>
                        </div>
                      </div>
                      <div class="match-handicap-item-wrap">
                        <div class="match-handicap-item">
                          <sportTeam :event="event" :issc="true" classes="none" :plyType="ftPlyType" :isRB="false" :widthL="widthColumn[0]"></sportTeam>

                          <div class="c-match-handicap" :id="'cmatch'+event.eveid">
                            <div class="vrow no-wrap">
                              <template v-for="ptype in fthtptype"><!-- Full Time & Half Time -->
                                <template v-for="(oddcaptData, n) in itemsRow">
                                  <!-- FT/HT column for home win/draw/away win score -->
                                  <div class="handicap-col">
                                    <template v-for="oddcapt in oddcaptData">
                                      <template v-if="excludeHT(oddcapt, ptype)">
                                        <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                          <div  class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon" :class="'bet-cs-'+ptype">
                                            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <!-- Show score label even no odds -->
                                              <div class="handicap-value-text">
                                                {{ getCSLabel(oddcapt) }}
                                              </div>
                                            </div>
                                            <cstgftht :event="event" :score="oddcapt" :plyType="ptype" :betType="btype"   :decimalNumber="1" />
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else-if="n == 0 && oddcapt == 'aos'">
                                        <div v-if="ptype == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div class="bet-item-wrap col3 absolute" style="height: 35px !important;"  :style="{ width: (widthColumn[1]*3) + 'px !important' }">
                                          <div class="c-bet-item yb-flex-center relative-position yb-family-odds normal csid1 show-odds-icon" :class="'bet-cs-'+ptype">
                                            <div class="handicap-value color-highlight" style="position: absolute; margin-right: 40px;">
                                              <span class="handicap-more" style="display: none;">&nbsp;</span>
                                              <div class="handicap-value-text AOS">
                                                {{ lang.sportAllBet['ALL_BET.LBL_AOS'] }}
                                              </div>
                                            </div>
                                            <cstgftht :event="event" :score="'aos'" :plyType="ptype" :betType="btype" :decimalNumber="1" />
                                          </div>
                                        </div>
                                      </template> <!--END AOS -->
                                      <template v-else-if="(n == 1 || n == 2) && oddcapt == 'odempty'">
                                        <div v-if="ptype == 2 && n == 1" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                          <div class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        </div>
                                        <div v-if="ptype == 1 && n == 1" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                      </template>
                                      <template v-else-if="(n == 1 || n == 2) && oddcapt == 'odlast'">
                                        <div v-if="ptype == 2 && n == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2 && n == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2 && n == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div v-if="ptype == 2 && n == 2" class="bet-item-wrap" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }"></div>
                                        <div class=" bet-item-wrap visibility" style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        </div>
                                      </template>
                                      
                                      <template v-else-if="(!excludeHT(oddcapt, ptype) && !oddcapt=='aos')">
                                        <div class="bet-item-wrap b " style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        </div>
                                      </template>
                                      <!-- <template v-else>
                                        <div class=" bet-item-wrapc " style="height: 35px !important;" :style="{ width: widthColumn[1] + 'px !important' }">
                                        </div>
                                      </template> -->
                                    </template>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </div>
                          <div class="media-col">
                            <div class="media-col-wrap">
                              <div class="icon-wrap after_tpl0 relative-position" :class="{ active: (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }">
                                <div class="v-icon switch-icon" @click="enterAllBet(event,1)" :class="{ active:  (firstEventEveid== event.eveid && livetvEveid!= event.eveid) }" :title="sportAllBetLang['ALL_BET.LBL_SCORE_BOAD']"></div>
                              </div>
                              <div class="yb-flex-center"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template> <!-- END sortedEventList -->
      </template>
    </template>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex'
// import EventBus from '../../events/event-bus'
import DateFilter from '@/vue/filters/date'

import cstgftht from '../../components/cs-tg-ftht'
import sportTime from './sportTimeColumn'
import sportTeam from './sportTeamColumn'
import todayHeader from './todayHeader'

import sportFavourite from '@/vue/mixins/favourite'
import allBetMixin from '@/vue/mixins/allBet'

export default {
  mixins: [allBetMixin, sportFavourite],
  components: {
    sportTime,
    sportTeam,
    todayHeader,
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sortedEventList',
      'sortedRBEventList',
      'selectedBettype',
      'selectedMarket',
      'int_fullHalfTime',
      'favouriteLgeEvents',
      'market',
      'frameWidthHeight',
      'livetv',
      'firstEvent',
      'account',
      'showRBLgeEve',
      'showLgeEve',
      'tvIconFlag',
    ]),
    livetvEveid: {
      get() {
        return this.$store.getters.livetv.eveid;
      }
    },
    firstEventEveid:{ 
      get() {
        let ft=this.$store.getters.firstEvent
        return Object.keys(ft).length>0 ? ft.eveid:0
      }
    },
    widthColumn: {
      get() {
        var fm = this.$store.getters.frameWidthHeight
        var pageCenter = fm.width.CenterPage_current;
        var betBoxWidthMin = fm.leagueTeam.betBoxWidthMin;
        var betBoxWidthMax = fm.leagueTeam.betBoxWidthMax;
        var leagueBoxWidthMin = fm.leagueTeam.leagueBoxWidthMin;
        var league = leagueBoxWidthMin;
        var team = betBoxWidthMin;
        var timeColumn = fm.leagueTeam.timeColumn;
        var favColumn = fm.leagueTeam.favColumn;
        var columnCount =6;
        var AvailableLT = pageCenter-timeColumn-favColumn-(betBoxWidthMin*columnCount)-leagueBoxWidthMin;
        if(AvailableLT>0){
          let TeamCal = AvailableLT * 0.7;
          team=betBoxWidthMin+(TeamCal/columnCount);
          team= Math.floor(team);
          if(team<betBoxWidthMin){
            team=betBoxWidthMin
          }else if(team>betBoxWidthMax){
            team=betBoxWidthMax;
          }
          let caladd = team-betBoxWidthMin
          if(caladd>0){
            AvailableLT = AvailableLT -((team-betBoxWidthMin)*columnCount)
            if(AvailableLT>0){
              league = AvailableLT+leagueBoxWidthMin
            }
          }else{
            league = AvailableLT+leagueBoxWidthMin
          }
        }else{
          league = AvailableLT+leagueBoxWidthMin
        }
        league=league-15; // minus scroll width + border use
        return [league,team, league+timeColumn] // Team column , team column , league title
      },
    },
  },
  data() {
    return {
      reloading: false,
      btype: (this.$store.getters.selectedMarket == '3') ? allBetMixin.data().rcsBetType : allBetMixin.data().csBetType,
      rbbtype: allBetMixin.data().rcsBetType,
      lang: window.lang,
      showhideAll: true,
      showRBhideAll: true,
      fthtptype: [allBetMixin.data().ftPlyType, allBetMixin.data().firstHtPlyType],
      itemsRow: [
        ['od10', 'od20', 'od21', 'od30', 'od31', 'od32', 'od40', 'od41', 'od42', 'od43', 'aos'],
        ['od00', 'od11', 'od22', 'od33', 'od44', 'odempty', 'odempty', 'odempty', 'odempty', 'odempty', 'odlast'],
        ['od01', 'od02', 'od12', 'od03', 'od13', 'od23', 'od04', 'od14', 'od24', 'od34', 'odlast']
      ],
      htExclude: ['od40', 'od41', 'od42', 'od43', 'od44', 'od04', 'od14', 'od24', 'od34'],
    }
  },
  mounted: function () {
  },
  methods: {
    enterAllBet(event,startTv) {
      if(this.$store.getters.account.previewFlag && !this.$store.getters.isLiveOn){
        if (window._hasRedirect && startTv == 2) {
          $('.login-redirect-dialog').show();
          return false;
        }
        startTv=1;
      }
      this.$store.dispatch('getMatchAllBet', {
        event: event,
        isRB: (event.rbstatus==1) ? true : false,
        token: token.arr_8,
        loadTemplate: startTv  // 1 open right score board only, 2 open live tv, 3 open right score board + all bet, 0 all bet only
      })
    },
    showMarketMatches(isRB) {
      if (isRB) {
        this.showRBhideAll = !this.showRBhideAll
      } else {
        this.showhideAll = !this.showhideAll
      }
    },
    excludeHT(oddcapt, ptype) {
      var r = false
      if (oddcapt != 'aos' && oddcapt != 'odempty' && oddcapt != 'odlast') {
        r = true
        if (ptype == 2 && (jQuery.inArray(oddcapt, this.htExclude) != '-1')) {
          r = false
        }
      }
      return r
    },
    chkCSOdds(event, oddcapt, ptype, btype) {
      var r = false
      if (event.od[ptype] && event.od[ptype][btype] && event.od[ptype][btype][oddcapt]) {
        r = true
      }
      return r
    },
    getCSLabel(od) {
      var capt = this.sportTableLang.template_lang['SPORT_TEMPLATE_2.' + od]
      if (od == 'aos') {
        capt = this.lang.sportAllBet['ALL_BET.LBL_AOS']
      }

      return capt
    },
    showhideMain() {
      this.showhideAll = (this.showhideAll) ? false : true;
      var key = ''
      for (key in this.sortedEventList) {
        this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      }
    },
    showLeg(key, isRB) {
      // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)

      if (!isRB) {
        this.$set(this.showLgeEve[key], 'hide', !this.showLgeEve[key].hide)
        // this.$set(this.sortedEventList[key], 'hide', !this.sortedEventList[key].hide)
      } else if (isRB && !this.showFavEvents) {
        this.$set(this.showRBLgeEve[key], 'hide', !this.showRBLgeEve[key].hide)
        // this.$set(this.sortedRBEventList[key], 'hide', !this.sortedRBEventList[key].hide)
      }

      if (this.showFavEvents && isRB) {
        this.$set(this.sortedFavRbEventList[key], 'hide', !this.sortedFavRbEventList[key].hide)
      }
    }
  },
  destroyed() {
    
  }
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/soccerCorrectScore.vue